import React from 'react';
import styled from '@emotion/styled';

const FLAGS_URL = 'https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.4.3/flags/4x3/';

type Props = {
  countryCode: string;
};

export const FlagIcon = ({ countryCode, ...props }: Props) => {
  if (typeof countryCode !== 'string') {
    return null;
  }

  const svgUrl = `${FLAGS_URL}${countryCode.toLowerCase()}.svg`;

  return <StyledImg alt="" {...props} src={svgUrl} />;
};

const StyledImg = styled('img')`
  display: inline-block;
  width: 1em;
  height: 1em;
  vertical-align: middle;
`;
